module.exports = __webpack_public_path__ + "img/horizontal_3_7_5012.983166d2.png";